import { StanModal } from '@/components';
import { useEffect, useState } from 'react';
import { OTPInput } from './OTPInput';
import { RecoveryTextInput } from './RecoveryTextInput';
import { useMFA } from '../hooks/useMFA';

export function MFAModal({
    isOpen,
    loginEndpoint,
    token,
    configName,
    onSuccess,
    onClose,
    onRecoverySuccess,
}: {
    isOpen: boolean;
    onClose: () => void;
    loginEndpoint: string;
    token: string;
    configName?: string;
    onSuccess?: () => void;
    onRecoverySuccess?: () => void;
}) {
    const [resetKey, setResetKey] = useState(0);
    const { resetWarningsAndErrors, validateConfigOTP, submitRecoveryText, error, warning, isLoading } = useMFA(
        token,
        loginEndpoint,
        onSuccess,
        onRecoverySuccess
    );
    const [showRecoveryTextInput, setShowRecoveryTextInput] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            resetWarningsAndErrors();
            setResetKey(key => key + 1);
            setShowRecoveryTextInput(false);
        }
    }, [isOpen, resetWarningsAndErrors]);

    const otpErrors = error?.errors?.otp ?? [];

    return (
        <StanModal
            title={showRecoveryTextInput ? 'Enter your recovery code' : 'Verify Code'}
            id='mfa-validation-modal'
            isOpen={isOpen}
            onClose={onClose}
            size='sm'
        >
            {!showRecoveryTextInput ? (
                <div>
                    <div className='text-dark flex flex-col items-center text-center'>
                        <p className='text-light m-1'>
                            Enter the one-time code from{' '}
                            <strong>{configName === '' ? 'authenticator app' : configName}</strong> to complete
                            authentication
                        </p>
                    </div>
                    <OTPInput
                        error={otpErrors}
                        warning={warning}
                        onResetErrors={resetWarningsAndErrors}
                        submitButtonText='Continue'
                        onSubmit={validateConfigOTP}
                        onShowRecovery={() => setShowRecoveryTextInput(true)}
                        showHelpAndRecovery
                        key={resetKey}
                    />
                </div>
            ) : (
                <div>
                    <div className='text-dark flex flex-col items-center text-center'>
                        <p className='text-light m-1'>
                            Use the one-time-use recovery code you saved during 2FA setup to sign-in
                        </p>
                    </div>
                    <RecoveryTextInput
                        error={otpErrors}
                        warning={warning}
                        onResetErrors={resetWarningsAndErrors}
                        submitButtonText='Continue'
                        onSubmit={submitRecoveryText}
                        onShowOTP={() => setShowRecoveryTextInput(false)}
                        loading={isLoading}
                    />
                </div>
            )}
        </StanModal>
    );
}
